import { render, staticRenderFns } from "./news-analytic.vue?vue&type=template&id=0b4f6619&"
import script from "./news-analytic.vue?vue&type=script&lang=js&"
export * from "./news-analytic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports